(function() {
  if (window.JorLookgreatV4Initialized) return;
  window.JorLookgreatV4Initialized = true;

  function initJorLookbook(root) {
    if (!root || root.dataset.jorLookbookInitialized === "true") return;
    root.dataset.jorLookbookInitialized = "true";

    var track = root.querySelector(".jor-lookbook__track");
    var carousel = root.querySelector(".jor-lookbook__carousel");
    var items = Array.prototype.slice.call(root.querySelectorAll(".jor-lookbook__item"));
    var prevBtn = root.querySelector(".jor-lookbook__arrow--prev");
    var nextBtn = root.querySelector(".jor-lookbook__arrow--next");
    var stacks = Array.prototype.slice.call(
      root.querySelectorAll(".jor-lookbook__stack-group")
    );

    if (!track || !items.length || !prevBtn || !nextBtn) return;

    function getTabKeyFromUrl() {
      if (!window.location || !window.location.search) return null;
      var params = new URLSearchParams(window.location.search);
      var key = params.get("tab");
      return key ? String(key) : null;
    }

    var selectedIndex = null;
    var urlTabKey = getTabKeyFromUrl();
    if (urlTabKey) {
      items.some(function(item, index) {
        if (item.getAttribute("data-tab-key") === urlTabKey) {
          selectedIndex = index;
          return true;
        }
        return false;
      });
    }

    if (selectedIndex === null && window.Shopify && Shopify.designMode && items.length > 0) {
      selectedIndex = 0;
    }

    function updateSelection() {
      if (selectedIndex === null) {
        items.forEach(function(item) {
          item.classList.remove("is-active", "is-dimmed");
        });
        return;
      }

      items.forEach(function(item, index) {
        if (index === selectedIndex) {
          item.classList.add("is-active");
          item.classList.remove("is-dimmed");
        } else {
          item.classList.remove("is-active");
          item.classList.add("is-dimmed");
        }
      });
    }

    function scrollActiveIntoView() {
      if (selectedIndex === null || !items[selectedIndex]) return;
      var item = items[selectedIndex];
      var trackRect = track.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var leftOverflow = itemRect.left < trackRect.left;
      var rightOverflow = itemRect.right > trackRect.right;

      if (!leftOverflow && !rightOverflow) return;

      var itemCenter = itemRect.left + (itemRect.width / 2);
      var trackCenter = trackRect.left + (trackRect.width / 2);
      var delta = itemCenter - trackCenter;
      var target = track.scrollLeft + delta;
      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      if (target < 0) target = 0;
      if (target > maxScrollLeft) target = maxScrollLeft;

      track.scrollTo({
        left: target,
        behavior: "smooth"
      });
    }

    function updateLookbook() {
      var activeKey = null;
      if (selectedIndex !== null && items[selectedIndex]) {
        activeKey = items[selectedIndex].getAttribute("data-tab-key");
      }
      stacks.forEach(function(el) {
        if (activeKey && el.getAttribute("data-tab-key") === activeKey) {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      });
    }

    function updateArrows() {
      var viewportWidth = track.clientWidth;
      var maxScrollLeft = Math.max(0, track.scrollWidth - viewportWidth);
      var hasOverflow = maxScrollLeft > 2;

      track.classList.toggle("jor-lookbook__track--overflowing", hasOverflow);

      viewportWidth = track.clientWidth;
      maxScrollLeft = Math.max(0, track.scrollWidth - viewportWidth);
      hasOverflow = maxScrollLeft > 2;

      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScrollLeft - 2 || !hasOverflow;
      var canScrollPrev = hasOverflow && !atStart;
      var canScrollNext = hasOverflow && !atEnd;

      track.classList.toggle("jor-lookbook__track--can-scroll-prev", canScrollPrev);
      track.classList.toggle("jor-lookbook__track--can-scroll-next", canScrollNext);

      if (carousel) {
        carousel.classList.toggle("jor-lookbook__carousel--can-scroll-prev", canScrollPrev);
        carousel.classList.toggle("jor-lookbook__carousel--can-scroll-next", canScrollNext);
      }

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;

      prevBtn.classList.toggle("is-disabled", atStart);
      nextBtn.classList.toggle("is-disabled", atEnd);
    }

    function slide(direction) {
      var viewportWidth = track.clientWidth;
      var maxScrollLeft = track.scrollWidth - viewportWidth;
      var step = viewportWidth * direction;
      var target = track.scrollLeft + step;

      if (target < 0) target = 0;
      if (target > maxScrollLeft) target = maxScrollLeft;

      track.scrollTo({
        left: target,
        behavior: "smooth"
      });

      setTimeout(updateArrows, 300);
    }

    items.forEach(function(item, index) {
      item.addEventListener("click", function() {
        if (selectedIndex === index) {
          selectedIndex = null;
        } else {
          selectedIndex = index;
        }
        updateSelection();
        updateLookbook();
        scrollActiveIntoView();
      });
    });

    prevBtn.addEventListener("click", function() {
      slide(-1);
    });

    nextBtn.addEventListener("click", function() {
      slide(1);
    });

    updateSelection();
    updateLookbook();
    scrollActiveIntoView();
    updateArrows();

    track.addEventListener("scroll", function() {
      window.requestAnimationFrame(updateArrows);
    });

    window.addEventListener("resize", function() {
      window.requestAnimationFrame(updateArrows);
    });
  }

  function initAll(container) {
    var scope = container || document;
    var roots = Array.prototype.slice.call(scope.querySelectorAll(".jor-lookbook"));
    roots.forEach(initJorLookbook);
  }

  function initOnLoad() {
    initAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOnLoad);
  } else {
    initOnLoad();
  }

  document.addEventListener("shopify:section:load", function(event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });

  document.addEventListener("shopify:section:select", function(event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
